import { Box, Typography } from '@mui/material';
import React from 'react';
import { sxConfig } from './calendarStyle';

const TooltipContent = ({ eventInfo }) => {
  const task = eventInfo?.event?.extendedProps;

  return (
    <Box>
      <Box sx={sxConfig.tooltipContent}>
        <Typography sx={sxConfig.tooltipContentFirstTyp}>Projekt:</Typography>
        <Typography>{task?.project?.projectName ?? 'N/A'}</Typography>
      </Box>
      <Box sx={sxConfig.tooltipContent}>
        <Typography sx={sxConfig.tooltipContentFirstTyp}>Feladat:</Typography>
        <Typography>{task?.simpleTaskName}</Typography>
      </Box>
      <Box sx={sxConfig.tooltipContent}>
        <Typography sx={sxConfig.tooltipContentFirstTyp}></Typography>
        <Typography> KIF:FMO: 8:00-16:00</Typography>
      </Box>
    </Box>
  );
};

export default TooltipContent;
